import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shouyefill"
})], -1);

const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "首页", -1);

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-yingyong"
})], -1);

const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "分类", -1);

const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-gouwuchekong"
}, null, -1);

const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, "购物车", -1);

const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-wode-wode"
})], -1);

const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, "我的", -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");

  const _component_router_link = _resolveComponent("router-link");

  const _component_van_badge = _resolveComponent("van-badge");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_router_view, null, {
    default: _withCtx(({
      Component
    }) => [_createVNode(_Transition, null, {
      default: _withCtx(() => [(_openBlock(), _createBlock(_KeepAlive, {
        include: _ctx.includeList,
        key: Component
      }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))], 1032, ["include"]))]),
      _: 2
    }, 1024)]),
    _: 1
  }), _createElementVNode("nav", null, [_createVNode(_component_router_link, {
    to: "/",
    class: "tab-bar-item"
  }, {
    default: _withCtx(() => [_hoisted_1, _hoisted_2]),
    _: 1
  }), _createVNode(_component_router_link, {
    to: "/category",
    class: "tab-bar-item"
  }, {
    default: _withCtx(() => [_hoisted_3, _hoisted_4]),
    _: 1
  }), _createVNode(_component_router_link, {
    to: "/shopcart",
    class: "tab-bar-item"
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_van_badge, {
      content: _ctx.$store.state.user.amountCarts,
      max: "99"
    }, {
      default: _withCtx(() => [_hoisted_5]),
      _: 1
    }, 8, ["content"])]), _hoisted_6]),
    _: 1
  }), _createVNode(_component_router_link, {
    to: "/user",
    class: "tab-bar-item"
  }, {
    default: _withCtx(() => [_hoisted_7, _hoisted_8]),
    _: 1
  })])], 64);
}